import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { Loader2 } from "lucide-react";

function FullPageLoading() {
  return (
    <div
      data-testid="auth-loading"
      className="min-h-screen flex items-center justify-center bg-[#F8FAFC]"
    >
      <Loader2 className="w-6 h-6 animate-spin text-[#0A192F]" />
    </div>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <FullPageLoading />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    if (user.role === "attorney" || user.role === "law_firm") {
      return <Navigate to="/attorney/dashboard" replace />;
    }
    if (user.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/" replace />;
  }
  return children;
}

export function AttorneyGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "attorney" && user.role !== "law_firm") {
    if (user.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/" replace />;
  }
  if (user.status !== "approved") return <Navigate to="/pending" replace />;
  const sub = user.subscription_status;
  if (sub !== "active" && sub !== "trialing") {
    return <Navigate to="/billing" replace />;
  }
  return children;
}
